// import ViewAndSignService from "../../../../services/IpadPreview/BeforeTake-off/viewandsign.service";

const state = {

    // OFPjsonData: [],
    // samplevalue : "",

};

const mutations = {

    // set_json_data(state, payload) {
    //     state.OFPjsonData = payload;
    //     state.samplevalue = "test";
    // }

};

const actions = {

    // async getJsonOFPData({commit},{FKey1,TableCode}){
    //     const  jsonData = await  ViewAndSignService.getJsonData(FKey1,TableCode);
    //     await  commit("set_json_data",jsonData);
    //     return  jsonData;
    // },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
